import { render } from "./WebsiteDetailImage.vue?vue&type=template&id=2b215e01&scoped=true&ts=true"
import script from "./WebsiteDetailImage.vue?vue&type=script&lang=ts"
export * from "./WebsiteDetailImage.vue?vue&type=script&lang=ts"

import "./WebsiteDetailImage.vue?vue&type=style&index=0&id=2b215e01&lang=scss&scoped=true"
import "./WebsiteDetailImage.vue?vue&type=style&index=1&id=2b215e01&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b215e01"]])

export default __exports__